import { clearUserToken } from '@devhacker/shared/features/auth/utils/token';
import { isRequiresAuth } from '@/utils';
import { leavePrivateChannel } from '~/components/Pusher/websockets-functions';
import { useIndexStore } from '~/store';

export function authErrorHandler(config: any, moduleName: string = 'unknown') {
  if (import.meta.server) return;

  const { $logger } = useNuxtApp();
  const log = $logger.withScope(`🚨 ${moduleName} error-handler`);
  const route = useRoute();

  if (config.response) {
    // Запрос был сделан, и сервер ответил кодом состояния
    // который выходит за пределы диапазона 2xx
    switch (config.response.status) {
      case 401:
      case 403:
        clearUserToken();
        useIndexStore().clearUser();
        return isRequiresAuth(route) ? safeRedirect('/', config.response.status) : undefined;
      default:
        log.error(`error at response`, config);
        break;
    }
  } else if (config.request) {
    // Запрос был сделан, но ответ не получен
    // `error.request` — это экземпляр XMLHttpRequest в браузере и экземпляр
    // http.ClientRequest в node.js
    log.error(`error at request`, config);
  } else {
    // Произошло что-то при настройке запроса, вызвавшее ошибку
    log.error(`error at settings`, config);
  }

  leavePrivateChannel();
}

function safeRedirect(path: string, code: number) {
  console.warn('[auth error] redirect to', path);
  import.meta.client ? (location.href = path) : navigateTo(path, { redirectCode: code });
}
